module.exports = __webpack_public_path__ + "media/images/vouchers/bien_etre-97d7a9d550caf1dbbe9ae1917660202a.png";